import React from 'react';
import styles from './style.module.scss';
import { connect } from 'react-redux';
import { fetchCurrentUserCourses, createArticleCourses, deleteArticleCourses, updateCourseArticle } from '../../../actions';
import _ from 'lodash';
import discuss from '../../pages/discuss';

interface IArticleCourseFormProps {
  courses: any;
  articleCourses: any;
  fetchCurrentUserCourses: any;
  createArticleCourses: Function;
  deleteArticleCourses: Function;
  updateCourseArticle: Function;
  article: any;
}

class ArticleCourseForm extends React.Component<IArticleCourseFormProps> {
  componentDidMount() {
    this.props.fetchCurrentUserCourses();
  }

  onChange = (e, field, course) => {
    e.preventDefault();
    let ac = _.find(this.props.articleCourses, ac => ac.id === course.id)
    if(field === 'add') {
      if(this.isChecked(field, course)) {
        this.props.deleteArticleCourses({article_id: this.props.article.id, courses: [{id: course.id}]})
      } else {
        this.props.createArticleCourses({article_id: this.props.article.id, courses: [{id: course.id, hidden_article: false}]})
      }
    } else if(ac) {
      if ( this.isChecked(field, ac) ) {
        this.props.updateCourseArticle({id: ac.pivot.id, [field]: false})
      } else {
        this.props.updateCourseArticle({id: ac.pivot.id, [field]: true})
      }
    }
  }

  isChecked = (field, course) => {
    if (field === 'add') {
      return !!_.find(this.props.articleCourses, ac => ac.id === course.id)
    } else {
      let ac = _.find(this.props.articleCourses, ac => ac.id === course.id)
      return ac && ac.pivot && !!ac.pivot[field]
    }
  }

  render() {
    const courses = _.sortBy(this.props.courses||[], c => c.name.toLowerCase());
    return (

    <div style={{overflow:'scroll', height: '300px'}}>
      <table className='table' style={{width: '100%', overflowX: 'auto'}}>
        <thead>
          <tr>
            <th><b>Course</b></th>
            <th><b>Add</b></th>
            <th><b>Blinders</b></th>
          </tr>
        </thead>
        <tbody>

        {
          courses && courses.map((course, index) => { // TODO: replace Index to course.id in Key
            return (
              <tr key={index}>
                <td>{course.name}</td>
                <td>
                  <input
                    type="checkbox"
                    name={'course_'+course.id}
                    onChange={(e) => this.onChange(e, 'add', course)}
                    checked={this.isChecked('add', course)}
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    name={'course_'+course.id}
                    onChange={(e) => this.onChange(e, 'hidden_article', course)}
                    checked={this.isChecked('hidden_article', course)}
                  />
                </td>
              </tr>
            );
          })
        }

        </tbody>
      </table>
    </div>

    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { user, discuss } = state;
	return {
    article: discuss.article,
    courses: user.courses,
    articleCourses: discuss.courses,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchCurrentUserCourses: () => dispatch(fetchCurrentUserCourses()),
        createArticleCourses: (courses) => dispatch(createArticleCourses(courses)),
        deleteArticleCourses: (courses) => dispatch(deleteArticleCourses(courses)),
        updateCourseArticle: (model) => dispatch(updateCourseArticle(model))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArticleCourseForm);
